<template>
  <AulaTemplate titulo="Pit Stop do Saber" numero="3" titleSize="6">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-card-title class="text-center primary--text">Opções</v-card-title>
          <v-card-text v-if="items.length" style="max-height: 260px; overflow: auto; font-size: .9rem; line-height: 1.2rem !important;">
            <v-list class="d-flex flex-wrap" style="gap: 10px;">
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                draggable="true"
                @dragstart="dragStart(index)"
                @dragend="dragEnd"
                :class="['draggable-item mb-2', { dragging: draggedItem === item, correct: item.correct, incorrect: item.incorrect }]"
                :style="{ border: 'solid 2px #333', 'max-width': $vuetify.breakpoint.smAndDown ? '100%' : '212px' }"
              >
                <v-list-item-content>{{ item.text }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="6">
        <!-- Direitos -->
        <v-card height="100%">
          <v-card-title class="text-center primary--text">Direitos</v-card-title>
          <v-card-text>
            <div class="dropzone" @dragover.prevent @drop="drop('direitos')">
              <v-list v-if="selected.direitos.length">
                <v-list-item
                  v-for="(item, index) in selected.direitos"
                  :key="index"
                  draggable="true"
                  @dragstart="dragStartFromSelected('direitos', index)"
                  @dragend="dragEnd"
                  :class="['mb-2', { dragging: draggedItem === item, correct: item.correct, incorrect: item.incorrect }]"
                  style="border: solid 2px #333"
                >
                  <v-list-item-content>{{ item.text }}</v-list-item-content>
                </v-list-item>
              </v-list>
              <!-- Texto e ícone se a lista estiver vazia -->
              <div v-else class="empty-dropzone">
                <v-icon large class="mb-2">mdi-drag</v-icon>
                <span>Clique e arraste as opções até aqui</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="6">
        <!-- Deveres -->
        <v-card height="100%">
          <v-card-title class="text-center primary--text">Deveres</v-card-title>
          <v-card-text>
            <div class="dropzone" @dragover.prevent @drop="drop('deveres')">
              <v-list v-if="selected.deveres.length">
                <v-list-item
                  v-for="(item, index) in selected.deveres"
                  :key="index"
                  draggable="true"
                  @dragstart="dragStartFromSelected('deveres', index)"
                  @dragend="dragEnd"
                  :class="['mb-2', { dragging: draggedItem === item, correct: item.correct, incorrect: item.incorrect }]"
                  style="border: solid 2px #333"
                >
                  <v-list-item-content>{{ item.text }}</v-list-item-content>
                </v-list-item>
              </v-list>
              <!-- Texto e ícone se a lista estiver vazia -->
              <div v-else class="empty-dropzone">
                <v-icon large class="mb-2">mdi-drag</v-icon>
                <span>Clique e arraste as opções até aqui</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-text class="d-flex justify-space-between">
            <v-btn class="mr-2" color="primary" outlined :disabled="!canReset" @click="reset"
              >Resetar</v-btn
            >

            <v-btn
              color="primary"
              @click="checkAnswers"
              :disabled="!isAllAllocated"
            >
              Checar
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="500">
      <v-card class="pa-6 rounded-lg">
        <v-card-text class="text-center d-flex flex-column" style="gap: 40px">
          <v-row justify="center">
            <v-col cols="4">
              <Lottie
                v-if="rightsCorrect && dutiesCorrect"
                :happy="true"
                :sad="false"
                data-aos="fade-up"
                data-aos-easing="ease"
                data-aos-duration="1000"
                data-aos-once="true"
              />

              <Lottie
                v-if="!rightsCorrect || !dutiesCorrect"
                :sad="true"
                :happy="false"
                data-aos="fade-up"
                data-aos-easing="ease"
                data-aos-duration="1000"
                data-aos-once="true"
              />
            </v-col>

            <v-col cols="12">
              <h3
                class="mb-2 success--text text-h5 font-weight-bold"
                v-if="rightsCorrect && dutiesCorrect"
              >
                Parabéns!
              </h3>

              <h3
                class="mb-2 error--text text-h5 font-weight-bold"
                v-if="!rightsCorrect || !dutiesCorrect"
              >
                Resposta incorreta!
              </h3>
              <p>{{ feedback }}</p>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">
              <NavButton
                v-if="rightsCorrect && dutiesCorrect"
                name="Voltar para aula"
                color="primary"
                block
                @button-click="back"
              ></NavButton>

              <NavButton
                v-else
                name="Fechar"
                color="primary"
                block
                @button-click="dialog = false"
              ></NavButton>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </AulaTemplate>
</template>

<script>
import AulaTemplate from "@/components/AulaTemplate.vue";
import Lottie from "@/components/Lottie.vue";
import NavButton from "@/components/NavButton.vue";

export default {
  components: {
    AulaTemplate,
    Lottie,
    NavButton,
  },

  data() {
    return {
      items: [
        {
          text: "Transitar em vias públicas que ofereçam condições adequadas de segurança e sinalização.",
          type: "direitos",
        },
        {
          text: "Ser notificado e apresentar defesa prévia e recurso às multas aplicadas, conforme os prazos e procedimentos estabelecidos pelo CTB.",
          type: "direitos",
        },
        {
          text: "Trafegar em vias com boa sinalização, iluminação adequada e em condições que não ofereçam risco à segurança.",
          type: "direitos",
        },
        {
          text: "Conduzir apenas veículos para os quais esteja devidamente habilitado, respeitando as categorias da sua Carteira Nacional de Habilitação (CNH).",
          type: "deveres",
        },
        {
          text: "Possuir Carteira Nacional de Habilitação (CNH) válida e compatível com o tipo de veículo que está dirigindo.",
          type: "deveres",
        },
        {
          text: "Garantir que seu veículo esteja em condições adequadas de uso, realizando manutenções preventivas e corretivas.",
          type: "deveres",
        },
        {
          text: "Respeitar os direitos dos pedestres, ciclistas e outros condutores, agindo de forma cortês e evitando atitudes que possam gerar risco ou desconforto aos demais.",
          type: "deveres",
        },
        {
          text: "Conduzir de maneira prudente, ajustando a velocidade e as manobras às condições da via, do tráfego e das condições climáticas.",
          type: "deveres",
        },
      ],
      selected: {
        direitos: [],
        deveres: [],
      },
      dialog: false,
      feedback: "",
      draggedItem: null,
      rightsCorrect: null,
      dutiesCorrect: null,
    };
  },

  computed: {
    isAllAllocated() {
      return this.items.length === 0;
    },

    canReset() {
      return (
        this.selected.direitos.length > 0 || this.selected.deveres.length > 0
      );
    },
  },

  methods: {
    shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },

    dragStart(index) {
      this.draggedItem = this.items[index];
    },

    dragStartFromSelected(category, index) {
      this.draggedItem = this.selected[category][index];
    },

    dragEnd() {
      this.draggedItem = null;
    },

    drop(category) {
      if (this.draggedItem) {
        Object.keys(this.selected).forEach((key) => {
          this.selected[key] = this.selected[key].filter(
            (item) => item !== this.draggedItem
          );
        });
        this.selected[category].push(this.draggedItem);
        this.items = this.items.filter((item) => item !== this.draggedItem);
        this.draggedItem = null;
      }
    },

    checkAnswers() {
      this.rightsCorrect = this.selected.direitos.every(
        (item) => item.type === "direitos"
      );
      this.dutiesCorrect = this.selected.deveres.every(
        (item) => item.type === "deveres"
      );

      this.selected.direitos.forEach((item) => {
        item.correct = item.type === "direitos";
        item.incorrect = item.type !== "direitos";
      });

      this.selected.deveres.forEach((item) => {
        item.correct = item.type === "deveres";
        item.incorrect = item.type !== "deveres";
      });

      if (this.rightsCorrect && this.dutiesCorrect) {
        this.feedback =
          "Você classificou todos os itens corretamente.";
      } else {
        this.feedback = "Ops! Alguns itens estão classificados incorretamente.";
      }
      this.dialog = true;
    },

    reset() {
      // Remove correct and incorrect properties
      this.selected.direitos.forEach((item) => {
        delete item.correct;
        delete item.incorrect;
      });
      this.selected.deveres.forEach((item) => {
        delete item.correct;
        delete item.incorrect;
      });
      this.items.forEach((item) => {
        delete item.correct;
        delete item.incorrect;
      });

      this.items = [
        ...this.selected.direitos,
        ...this.selected.deveres,
        ...this.items,
      ];
      this.selected.direitos = [];
      this.selected.deveres = [];
      this.shuffle(this.items);
    },

    back() {
      this.dialog = false;
      this.$router.push({
        path: "/topico-3",
        query: { goTo: "goToPitStop_3" },
      });
    },
  },

  created() {
    this.shuffle(this.items);
    this.$store.commit("ADICIONAR_SCORE", "atividade_1_topico_03");
  },
};
</script>

<style>
.draggable-item {
  cursor: grab;
}
.draggable-item:hover {
  background-color: #ddd;
}
.draggable-item.dragging {
  background-color: #ddd;
  cursor: grabbing;
}
.dropzone {
  border: 2px dashed #ccc;
  min-height: 150px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.empty-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #999;
}
.correct {
  background-color: green;
  color: white !important;
}
.incorrect {
  background-color: red;
  color: white !important;
}
</style>